import React from "react";
import Carousel from "../../Components/Carousel";
import { useNavigate } from "react-router-dom";

export default function OnBoarding2() {
  const navigate = useNavigate();

  return (
    <div className="onboarding-container">
      <div className="onboard-content d-flex flex-column">
        <Carousel isGoto={false} items={CarouselItems(navigate)} />
      </div>
    </div>
  );
}
const SkipButton = () => {
  const navigation = useNavigate();
  return (
    <button className="skip-btn" onClick={() => navigation("/register")}>
      SKIP
    </button>
  );
};
const CarouselItems = (navigate) => [
  {
    key: 1,
    item: ({ handleNext }) => (
      <div className="carousel-item first-carousel active">
        <div className="d-flex">
          <div
            className="empoweredman-image"
            style={{
              backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/images/empoweredman1.jpeg')`,
            }}
          ></div>
          <div className="get-started2 onboardsplash1">
            <div
              style={{
                justifyContent: "end",
                alignItems: "end",
                display: "flex",
              }}
            >
              <SkipButton />
            </div>
            <div
              style={{
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
              className="onsplash-cards"
            >
              <div>
                <img
                  style={{ width: "109.35px", height: "123.93px" }}
                  src="/images/brave.png"
                  alt=""
                />
              </div>
              <div
                className="d-flex flex-column"
                style={{ gap: "32px", marginTop: "32px" }}
              >
                <div className="d-flex flex-column" style={{ gap: "12px" }}>
                  <h1
                    style={{ color: "rgba(230, 236, 241, 1)" }}
                    className="text-heading-h1"
                  >
                    Upgrade Yourself
                  </h1>
                  <span
                    style={{ color: "rgba(230, 236, 241, 1)" }}
                    className="text-body-b2"
                  >
                    Earn points to level up and win at life
                  </span>
                </div>
                <div>
                  <button
                    className="get-started-btn next-slide"
                    onClick={handleNext}
                    style={{ width: "240px" }}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ),
  },
  {
    key: 2,
    item: ({ handleNext }) => {
      return (
        <div className="carousel-item">
          <div className="d-flex">
            <div
              className="empoweredman-image"
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/images/empoweredman2.jpeg')`,
              }}
            ></div>
            <div className="get-started2 onboardsplash2">
              <div
                style={{
                  justifyContent: "end",
                  alignItems: "end",
                  display: "flex",
                }}
              >
                <SkipButton />
              </div>
              <div
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
                className="onsplash-cards"
              >
                <div>
                  <img
                    style={{ width: "109.35px", height: "123.93px" }}
                    src="/images/brave.png"
                    alt=""
                  />
                </div>
                <div
                  className="d-flex flex-column"
                  style={{ gap: "32px", marginTop: "32px" }}
                >
                  <div className="d-flex flex-column" style={{ gap: "12px" }}>
                    <h1
                      style={{
                        color: "rgba(230, 236, 241, 1)",
                        fontFamily: "Poppins",
                        fontWeight: "600",
                        fontSize: "36px",
                        lineHeight: "57px",
                      }}
                    >
                      Build Powerful Habits
                    </h1>
                    <span
                      style={{
                        color: "rgba(230, 236, 241, 1)",
                        fontFamily: "Poppins",
                        fontWeight: "400",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      Stay consistent with checklists and unlock <br />
                      rewards and create a lasting change
                    </span>
                  </div>
                  <div>
                    <button
                      className="get-started-btn next-slide"
                      style={{ width: "240px" }}
                      onClick={handleNext}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    },
  },
  {
    key: 3,
    item: ({ handleNext }) => {
      return (
        <div className="carousel-item">
          <div className="d-flex">
            <div
              className="empoweredman-image"
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/images/empoweredman3.jpeg')`,
              }}
            ></div>
            <div className="get-started2 onboardsplash3">
              <div
                style={{
                  justifyContent: "end",
                  alignItems: "end",
                  display: "flex",
                }}
              >
                <SkipButton />
              </div>
              <div
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
                className="onsplash-cards"
              >
                <div>
                  <img
                    style={{ width: "109.35px", height: "123.93px" }}
                    src="/images/brave.png"
                    alt=""
                  />
                </div>
                <div
                  className="d-flex flex-column"
                  style={{ gap: "32px", marginTop: "32px" }}
                >
                  <div className="d-flex flex-column" style={{ gap: "12px" }}>
                    <h1
                      style={{
                        color: "rgba(230, 236, 241, 1)",
                        fontFamily: "Poppins",
                        fontWeight: "600",
                        fontSize: "36px",
                        lineHeight: "57px",
                      }}
                    >
                      Join an ELITE Tribe
                    </h1>
                    <span
                      style={{
                        color: "rgba(230, 236, 241, 1)",
                        fontFamily: "Poppins",
                        fontWeight: "400",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      Connect with a community of high performing <br />
                      men, including world-class experts & coaches
                    </span>
                  </div>
                  <div>
                    <button
                      className="get-started-btn"
                      style={{ width: "240px" }}
                      onClick={() => navigate("/register")}
                    >
                      Done
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    },
  },
];

// <button
// type="button"
// data-bs-target="#carouselExampleIndicators"
// data-bs-slide-to="1"
// aria-label="Slide 2"
// ></button>
// <button
// type="button"
// data-bs-target="#carouselExampleIndicators"
// data-bs-slide-to="2"
// aria-label="Slide 3"
// ></button>
